
import postHttp from './../../plugin/extendFn/postHttp'
import loginService from './../../plugin/extendFn/loginService'
import storageService from '../../plugin/extendFn/storageService';

async function UserInfoGard(to, from, next) {

 var loginDTO= storageService.getLoginDTO();

  if(["Code","userinfo"].indexOf(to.name)>=0 // 微信登录不做限制。 
    || !loginDTO // 未登录，不做验证
  )
  {
    // 忽略的路由。 
    next()
  }
  else
  {
    var uPhone= loginDTO.student.uPhone;
    var uOrg= loginDTO.student.uOrg;

    console.log("gard >>> SubscribeGard ----------------------------------------");
    console.log(`gard >>> SubscribeGard uPhone =${uPhone} ; uOrg=${uOrg}`);
    if(!uPhone || !uOrg)  // 如果没有填写电话号码。 跳转填写注册页面。 
    {
        next({
            name: "userinfo"
          });
    }
    else
    {
        next();
    }
  }
}

export default UserInfoGard;


// WEBPACK FOOTER //
// ./src/router/gard/UserInfoGard.js